import { types } from '../../actions/backendMain';
import { types as deviceTypes } from '../../actions/backendDevice';
import { types as snoozeTypes } from '../../actions/backendSnooze';
import { USER_PROFILE_FETCH_SUCCESS } from '../../actions/actionTypes/userProfile';
import type { AudioDeviceInfo } from '../../types';

const setIsTrainerActive = (payload: { snoozeFor?: number }) => {
    return Boolean((payload?.snoozeFor ?? 0) <= 0);
};

export const initialState = {
    systemInfoConnectionOpened: false,
    mainConnectionOpened: false,
    recordingInfo: null as object | null,
    isTrainerActive: false,
    deviceListError: false
};

interface ReducerAction {
    type?: string;
    payload?: {
        snoozeFor?: number;
        version?: string;
        mics?: AudioDeviceInfo[];
        speakers?: AudioDeviceInfo[];
        recordingInfo?: object | null;
    };
}

export default function mainReducer(state = initialState, { type, payload = {} }: ReducerAction = {}) {
    switch (type) {
        case types.MAIN_CONNECTION_OPENED:
            return {
                ...state,
                mainConnectionOpened: true
            };
        case snoozeTypes.SET_SNOOZE_TIMER_SUCCESS: {
            return {
                ...state,
                isTrainerActive: false
            };
        }
        case types.MAIN_CONNECTION_CLOSED:
            return { ...state, mainConnectionOpened: false };
        case types.AUDIO_SYSTEM_INFO_CONNECTION_OPENED:
            return { ...state, systemInfoConnectionOpened: true };
        case types.AUDIO_SYSTEM_INFO_CONNECTION_CLOSED:
            return { ...state, systemInfoConnectionOpened: false };

        case types.DAEMON_VERSION_RECEIVED:
            return {
                ...state,
                version: payload.version
            };
        case types.DEVICE_LIST_RECEIVE_ERROR:
            return {
                ...state,
                deviceListError: true
            };
        case types.DEVICE_LIST_RECEIVED: {
            return {
                ...state,
                deviceList: {
                    mics: payload.mics,
                    speakers: payload.speakers
                }
            };
        }
        case deviceTypes.RECORDING_INFO_RECEIVED:
            return {
                ...state,
                recordingInfo: payload.recordingInfo
            };
        case USER_PROFILE_FETCH_SUCCESS: {
            return { ...state, isTrainerActive: setIsTrainerActive(payload) };
        }
        default:
            return state;
    }
}
